import(/* webpackMode: "eager" */ "/app/node_modules/bootstrap/dist/css/bootstrap.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-free/css/all.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@fortawesome/fontawesome-free/css/v4-shims.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@yaireo/tagify/dist/tagify.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@soprisapps/react-fonticonpicker/dist/fonticonpicker.base-theme.react.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/flaticon/flaticon.css");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/images/placeholders/placeholder-video.png");
;
import(/* webpackMode: "eager" */ "/app/packages/components/assets/sbicon/sbicon.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@soprisapps/react-fonticonpicker/dist/fonticonpicker.material-theme.react.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-datetime/css/react-datetime.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-big-calendar/lib/css/react-big-calendar.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/cropperjs/dist/cropper.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/rc-menu/assets/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/jsdifflib/index.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-grid-layout/css/styles.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-resizable/css/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/footer/Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/GoogleAnalyticsScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/components/header/LanguageTool/LanguageTool.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileNavFooter"] */ "/app/packages/components/components/header/navigation/MobileNav/MobileNavFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/packages/components/components/utilities/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/components/pages/PageBlockPage/styles/scopedContentBuilderEditor.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/components/stores/ClientTransitionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["StoreContext"] */ "/app/packages/components/stores/StoreContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/fonts.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/css/instagram.css");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/css/poll.css");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/css/googlefileviewer.css");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/css/ui.fancytree-win7.css");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/style.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_reset.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_organization.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_notification-styles.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/_floating-blocks-theme.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/schoolblocks/src/scss/scopedHtml.scss");
;
import(/* webpackMode: "eager" */ "/app/packages/components/styles/_variables.module.scss");
